module.exports = __webpack_public_path__ + "3602daf18f89f0f17c48d3c9ba42fa42.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-4.png
// module id = 2612
// module chunks = 0